import { app } from "@microsoft/teams-js";
import { TeamsRecipientGroupMember } from "@teams/types";

import { clientEventTracker } from "../clientTelemetry";

export function getAudienceFromTeamsContext(
  teamsContext: app.Context
): TeamsRecipientGroupMember | null {
  if (teamsContext?.meeting?.id) {
    const id =
      teamsContext?.chat?.id || (teamsContext.channel?.id as string) || teamsContext?.meeting?.id;
    if (!id) {
      clientEventTracker.trackFatalError(
        "getaudience/error",
        { userId: teamsContext.user!.id, tenantId: teamsContext.user!.tenant!.id },
        {
          context: teamsContext,
          message: "Could not fetch the recpient id while creating polly.",
        }
      );
      return null;
    }
    return {
      type: "meeting",
      id: id,
      groupId:
        teamsContext?.team?.internalId ||
        teamsContext.team?.groupId ||
        (teamsContext?.chat?.id as string),
      name: teamsContext.channel?.displayName,
      meetingId: teamsContext?.meeting?.id,
      messageId: teamsContext.app.parentMessageId || undefined,
    };
  } else if (teamsContext?.chat?.id) {
    return {
      type: "groupChat",
      id: teamsContext?.chat?.id,
      groupId: teamsContext?.chat?.id,
      name: teamsContext.channel?.displayName || "Group chat",
    };
  } else if (teamsContext.channel?.id) {
    return {
      type: "channel",
      id: teamsContext.channel?.id,
      groupId: teamsContext?.team?.internalId ?? teamsContext.channel?.id,
      name: teamsContext.channel?.displayName || "General",
    };
  } else if (teamsContext.user?.id) {
    return {
      type: "user",
      id: teamsContext.user.id,
      groupId: "",
      name: teamsContext.user.userPrincipalName || teamsContext.user.userPrincipalName || "User",
    };
  }
  return null;
}
